export class UpdateStatusProcessModel
{
    IdRequest:number;
    IdMenu:number;
}